<script setup lang="ts">
import { computed } from "vue";

import StatusInfo from "@/components/link/StatusInfo.vue";
import StickerInfo from "@/components/link/StickerInfo.vue";
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import ListItem from "@/components/ui/ComplexList/ListItem.vue";
import ListItemSubtitleSticky from "@/components/ui/ComplexList/ListItemSubtitleSticky.vue";
import TypeDot from "@/components/ui/TypeDot/TypeDot.vue";
import type { ResolvedCard } from "@/model/card";
import { useBoardsStore } from "@/store/boards";
import { cardColor } from "@/store/card";

const props = defineProps<{ item: ResolvedCard; boardId: string }>();

const boardsStore = useBoardsStore();

const dotColor = computed(() => {
  const board = boardsStore.boards[props.boardId];
  if (!board) return props.item.type.color;
  return cardColor({ ...props.item, teamId: props.item.team?.id ?? null }, board);
});
</script>

<template>
  <ListItem clickable class="list-item-sticky-search">
    <template #before>
      <TypeDot size="medium" :color="dotColor" class="type-dot" />
    </template>

    <!-- Sticky text -->
    <BaseTooltip position="bottom" class="text-container">
      <div class="text">{{ item.text }}</div>
      <template #content>{{ item.text }}</template>
    </BaseTooltip>

    <!-- Details -->
    <template v-if="item.status || item.almId || item.flagType" #subtitle>
      <ListItemSubtitleSticky>
        <StatusInfo
          v-if="item.status"
          :status="item.status"
          data-testid="search-result-item-status"
        />
        <div v-if="item.almId">
          {{ item.almId }}
        </div>
        <StickerInfo v-if="item.flagType" :sticker="item.flagType" />
      </ListItemSubtitleSticky>
    </template>
  </ListItem>
</template>

<style lang="scss" scoped>
@use "@/styles/font";
@use "@/styles/variables/colors";
@use "@/styles/mixins/utils";

.list-item-sticky-search {
  .type-dot {
    width: 18px;
    height: 18px;
    padding: 0 1px;
  }

  .text-container {
    max-width: 100%;

    .text {
      @include utils.ellipsis;
    }
  }
}
</style>
